import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import './Venue.css';

const venueDetails = {
  name: 'Balan Farms',
  address: '99/4, 4th Main Rd, Nataraja Layout, Santrupthi Nagar, JP Nagar 7th Phase, Arekere, Bengaluru, Karnataka 560078, India',
  googleMapsUrl: 'https://maps.app.goo.gl/wbUuGVbiXtVj2oKDA',
};

const Venue = () => {
  return (
    <Box className="venue-section">
      <Typography variant="h4" className="venue-title">
        Wedding Venue
      </Typography>
      <Box className="venue-details">
        <Typography variant="h5" className="venue-name">{venueDetails.name}</Typography>
        <Typography variant="body1" className="venue-address">{venueDetails.address}</Typography>
        <Link 
          href={venueDetails.googleMapsUrl} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="venue-map-link"
        >
          View on Google Maps
        </Link>
      </Box>
    </Box>
  );
};

export default Venue;
